import { Component, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { MyconfigurationService } from './myconfiguration.service';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';

@Component({
  selector: 'app-myconfiguration',
  templateUrl: './myconfiguration.component.html',
  styleUrls: ['./myconfiguration.component.css']
})
export class MyconfigurationComponent {

  tableData: any[] = [];
  isDropdownOpen = false;
  items: MenuItem[] | undefined;
  selectedItem: MenuItem | null = null;
  compliancemyconfigurationlist: any;
  ref: DynamicDialogRef | undefined;
  commonScrollHeight = '';
  rowsize: number = 10;
  totalRecords: number = 0;
  selectedProduct = false;
  options = [{ label: 10, value: 10 }];
  paginatorArray = [];
  visible: boolean = false;
  tempuse: any;
  psition = 'top';
  templatedownloadtext = '';
  excel_paragraph = '';
  products: Product[] = [];
  productList: DefaultProduct[] = [];
  selectedProductId: string = '';
  modifyForm: FormGroup;
  emailaddress: any;
  emailButtonValue: any;
  CSRFToken = "";
  emailStatus: boolean;

  activeflag = "N";
  requireVertLabel = "";
  isContractType = "";
  userrole = 0;
  verticalLabelName = ""
  customerLabelName = ""
  contractTypeLabel = ""
  labelowner = ""
  labelmanager = ""
  reportStatus = "Y";

  //
  circularChartControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];
  calendarControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];
  complianceGraphControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  nonComplianceGraphControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  complianceTrendControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  entityControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  verticalControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  departmentControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  locationControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  customerControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  stateControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  contractTypeControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  ownerControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  managerControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  mailControl = [
    { 'labelname': 'Yes', 'value': 'Y' },
    { 'labelname': 'No', 'value': 'N' }
  ];

  lawCategoryControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  yearWiseControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  ownerRejectionControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  managerRejectionControl = [
    { 'labelname': 'Show', 'value': 'Y' },
    { 'labelname': 'Hide', 'value': 'N' }
  ];

  frequencyControl = [{ labelname: 'Select', value: '-1' },
  { labelname: 'Monthly', value: 'M' },
  { labelname: 'Fortnightly', value: 'F' },
  { labelname: 'Weekly', value: 'W' }
  ];

  adminEmail: string = '';
  type: string = '';
  activeFlag: string = '';
  formBuilder: any;


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();

  }
  constructor(
    public router: Router, private fb: FormBuilder,
    private myconfigurationService: MyconfigurationService, private utilityservice: Utilityservice,
    public dialogService: DialogService,
    public PagehelpmodalService: PagehelpmodalService
  ) {
    //this.gettoken();
    this.modifyForm = this.fb.group({
      products: [],
      defaultProduct: null,
      compproductid: ['1', Validators.required],
      cw1: ['Y'],
      cw2: ['Y'],
      cw3: ['Y'],
      cw4: ['Y'],
      cw5: ['Y'],
      cw6: ['Y'],
      cw7: ['Y'],
      cw8: ['Y'],
      cw9: ['Y'],
      cw10: ['Y'],
      cw11: ['Y'],
      cw12: ['Y'],
      cw13: ['Y'],
      cw14: ['Y'],
      cw15: ['Y'],
      cw16: ['Y'],
      cw17: ['Y'],
      cw18: ['Y'],
      cw19: ['Y'],
      cw20: ['Y'],
      frequency: ['-1'],
      monthday: [''],
      selectedDefaultProduct: [''],
    });
  }

  public validation_message = {
    adminEmail: [
      { type: 'required', message: 'Email is required' },
      { type: 'SPACERISTRICT', message: 'Spaces Not Allowed at the Beginning or at the End' },
      { type: 'EMAIL', message: 'Email not valid' }
    ]
  }
  getErrorMessages() {
    const errorMessages = {
      adminEmail: {
        REQUIRED: 'Email is required',
        EMAIL: 'Invalid Email pattern'
      },
    };
    this.validation_message = {
      adminEmail: [
        { type: 'required', message: 'Email is required' },
        { type: 'SPACERISTRICT', message: 'Spaces Not Allowed at the Beginning or at the End' },
        { type: 'EMAIL', message: 'Email not valid' }
      ]
    };
  }

  formInitiliaze() {
    this.modifyForm = this.formBuilder.group({
      adminEmail: ['', Validators.compose([
        Validators.required,
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.EMAIL)])]
    })
  }
  verifyEmail(email: string) {
    const payload = {
      verifyemailaddress: email,
      activeflag: this.activeFlag,
      type: this.type,
      csrftoken: this.CSRFToken,
    };
    this.myconfigurationService.exists(email).subscribe(
      (response: any) => {
        if (!response || response.length === 0 || response[0].response) {
          const timestamp = new Date().toLocaleString();
          Swal.fire({
            icon: 'error',
            title: 'Invalid Data',
            text: response[0]?.response || 'Data not found'
          });
        } else if (response[0].count == 0) {
          Swal.fire({
            icon: 'success',
            title: 'Verification',
            text: 'Kindly check entered address for further communication.',
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Email Already Exists',
            text: 'The provided email address is already in use.',
          });
        }

      },
      (error) => {
        console.error('Error checking email existence:', error);
        Swal.fire({
          icon: 'error',
          title: 'API Error',
          text: 'An error occurred while checking email existence.',
        });
      }
    );
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.getdetails();
    this.myconfigurationService.getProducts().subscribe(
      (data: Product[]) => {
        this.products = data;
        this.modifyForm.get('products').setValue(data.filter(d => d.istopmenu == "Y").map(d => d.productid));
      },
      (error) => {
        console.error('Error fetching products:', error);
      }
    );

    this.myconfigurationService.getdefproduct().subscribe(
      (data: DefaultProduct[]) => {
        this.productList = data;
        if (data.length) {
          const defaultId = data[0].defaultProductid;
          const match = data.find(d => d.productid === defaultId);

          if (match) {
            setTimeout(() => {
              this.modifyForm.patchValue({ defaultProduct: match.productid });
            }, 0);
          }
        }
      },
      (error) => {
        console.error('Error fetching default product:', error);
      }
    );


    this.fetchDashboardConfiguration('1');
    this.getfrequencydayconfiguration();

  }

  emailToggle(event: any) {
    const selectedValue = event.value;
    this.reportStatus = selectedValue;

    if (this.reportStatus === 'Y') {
      this.modifyForm.get('frequency')?.setValue('-1');
    }
  }


  handlePageChange(event: any) {
    this.rowsize = event.rows;
  }


  productModify() {
    const selectedOptions = this.modifyForm.get('products')?.value;
    const selectedCount = selectedOptions ? selectedOptions.length : 0;

    if (selectedCount == 0) {
      Swal.fire({
        title: "Please select at-least one product to appear on top menu"
      });
      return;
    }

    if (selectedCount > 6) {
      Swal.fire({
        title: "You can only choose maximum of six products to appear on the top menu"
      });
      return;
    }

    const formData = this.modifyForm.value;
    this.gettoken().subscribe((res) => {
      const token = res.csrf;

      this.myconfigurationService.userproductconfigurationmodify({
        ...formData,
        csrftoken: token
      }).subscribe({
        next: () => {
          Swal.fire({
            title: "Your dashboard display configuration modified successfully!",
            icon: 'success',
            confirmButtonColor: 'green',
            confirmButtonText: 'Ok'
          }).then(() => {
            window.location.reload();
          });
        },
        error: (error) => {
          console.error('Error modifying the dashboard configuration:', error);
          window.location.reload();
        }
      });
    });
  }

  toggleEmailStatus() {
    this.gettoken().subscribe((token) => {
      this.CSRFToken = token;

      if (this.emailButtonValue == 'Verify') {
        const payload = {
          verifyemailaddress: this.emailaddress,
          activeflag: "Y",
          type: 'U',
          csrftoken: this.CSRFToken,
        };

        this.myconfigurationService.verifyemail(payload).subscribe(
          () => window.location.reload(),
          (error) => console.error(error)
        );

      } else {
        this.myconfigurationService.toggleEmailStatus(this.CSRFToken).subscribe(
          () => window.location.reload(),
          (error) => console.error(error)
        );
      }
    });
  }
  // gettoken() {
  //   this.CSRFToken = '';
  //   this.utilityservice.getCSRFtoken().subscribe(res => {
  //     this.CSRFToken = res.csrf;
  //   })
  // }

  gettoken() {
    return this.utilityservice.getCSRFtoken();
  }
  fetchDashboardConfiguration(productid: string): void {
    this.myconfigurationService.getUserDashboardConfiguration(productid)
      .subscribe((retval: any[]) => {
        if (retval[0].response) {
          const timestamp = new Date().toLocaleString();
          Swal.fire({
            icon: 'error',
            title: 'Invalid Data',
            text: retval[0]?.response || 'Data not found'
          });
        }
        retval.forEach(item => {
          const widgetid = item.widgetid;
          if (widgetid == 1) {
            this.modifyForm.patchValue({
              circularChartControl: "N",
              cw1: "N"
            });
          }
          if (widgetid == 2) {
            this.modifyForm.patchValue({
              cw2: "N",
              calendarControl: "N"

            });
          }
          if (widgetid == 3) {
            this.modifyForm.patchValue({
              cw3: "N",
              complianceGraphControl: "N"


            });
          }
          if (widgetid == 4) {
            this.modifyForm.patchValue({
              cw4: "N",
              nonComplianceGraphControl: "N"
            });
          }
          if (widgetid == 5) {
            this.modifyForm.patchValue({
              cw5: "N",
              complianceTrendControl: "N"
            });
          }
          if (widgetid == 6) {
            this.modifyForm.patchValue({
              cw6: "N",
              departmentControl: "N"
            });
          }
          if (widgetid == 7) {
            this.modifyForm.patchValue({
              cw7: "N",
              locationControl: "N"
            });
          }
          if (widgetid == 8) {
            this.modifyForm.patchValue({
              cw8: "N",
              entityControl: "N"
            });
          }
          if (widgetid == 9) {
            this.modifyForm.patchValue({
              cw9: "N",
              verticalControl: "N"
            });
          }
          if (widgetid == 10) {
            this.modifyForm.patchValue({
              cw10: "N"
            });
          }
          if (widgetid == 11) {
            this.modifyForm.patchValue({
              cw11: "N",
              customerControl: "N"
            });
          }
          if (widgetid == 12) {
            this.modifyForm.patchValue({
              cw12: "N",
              stateControl: "N"
            });
          }
          if (widgetid == 13) {
            this.modifyForm.patchValue({
              cw13: "N",
              contractTypeControl: "N"
            });
          }
          if (widgetid == 14) {
            this.modifyForm.patchValue({
              cw14: "N",
              ownerControl: "N"
            });
          }
          if (widgetid == 15) {
            this.modifyForm.patchValue({
              cw15: "N",
              managerControl: "N"
            });
          }
          if (widgetid == 16) {
            this.modifyForm.patchValue({
              cw16: "N",
              mailControl: "N"
            });
            this.reportStatus = "N";
          }
          if (widgetid == 17) {
            this.modifyForm.patchValue({
              cw17: "N",
              lawCategoryControl: "N"
            });
          }
          if (widgetid == 18) {
            this.modifyForm.patchValue({
              cw18: "N",
              yearWiseControl: "N"
            });
          }
          if (widgetid == 19) {
            this.modifyForm.patchValue({
              cw19: "N",
              ownerRejectionControl: "N"
            });
          }
          if (widgetid == 20) {
            this.modifyForm.patchValue({
              cw20: "N",
              managerRejectionControl: "N"
            });
          }
        })
      },
        error => {
          console.error('Error fetching dashboard configuration:', error);
        });
  }


  getfrequencydayconfiguration(): void {
    const activeFlag = 'Y';
    this.myconfigurationService.getfrequencydayconfiguration(activeFlag).subscribe(
      (response) => {
        if (!response || response.length === 0 || response[0].response) {
          const timestamp = new Date().toLocaleString();
          Swal.fire({
            icon: 'error',
            title: 'Invalid Data',
            text: response[0]?.response || 'Data not found'
          });
        } else {
          response.forEach(item => {
            this.labelmanager = response[0]?.labelmanager;
            this.labelowner = response[0]?.labelowner;
            this.verticalLabelName = response[0]?.verticalLabelName;
            this.contractTypeLabel = response[0]?.contractTypeLabel;
            this.customerLabelName = response[0]?.customerLabelName;
            this.requireVertLabel = response[0]?.requireVertLabel;
            this.isContractType = response[0]?.isContractType;
            this.userrole = response[0]?.userrole;
          });
          this.modifyForm.patchValue({
            frequency: response[0].frequency

          });
          this.modifyForm.patchValue({
            monthday: response[0].mailday?.toString() || ''
          });
        }
      },
      (error) => {
        console.error('Error fetching frequency day configuration:', error);
      }
    );
  }

  getdetails(): void {
    this.myconfigurationService.getdetails().subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.emailaddress = response[0]?.emailaddress;
          this.emailButtonValue = response[0]?.activeFlag;
        }
      },
      (error) => {
        console.error('Error fetching email:', error);
      }
    );
  }

  modify() {
    const formValue = this.modifyForm.value;

    this.gettoken().subscribe((res) => {
      this.CSRFToken = res.csrf;

      const rawValue = formValue.monthday;
      const dayValue = Number(String(rawValue).substring(0, 2));

      if (formValue.cw16 === 'Y') {

        if (formValue.frequency === '-1' || !formValue.frequency) {
          Swal.fire({ title: 'Please Select Frequency (Periodic Interval)..' });
          return;
        }

        const dayInput = formValue.monthday?.toString().trim();
        if (!dayInput) {
          Swal.fire({ title: 'Please enter Day' });
          return;
        }

        if (!/^[0-9]+$/.test(dayInput)) {
          Swal.fire({ title: 'Day should be only numeric..' });
          return;
        }

        if (formValue.frequency === 'M' && (dayValue < 1 || dayValue > 31)) {
          Swal.fire({ title: 'In case of Monthly, please enter Day between 1 to 31' });
          return;

        } else if (formValue.frequency === 'F' && (dayValue < 1 || dayValue > 15)) {
          Swal.fire({ title: 'In case of Fortnightly, please enter Day between 1 to 15' });
          return;

        } else if (formValue.frequency === 'W' && (dayValue < 1 || dayValue > 7)) {
          Swal.fire({ title: 'In case of Weekly, please enter Day between 1 to 7' });
          return;
        }
      }

      const widgetConfig: any = {};
      for (let i = 1; i <= 20; i++) {
        widgetConfig[`cw${i}`] = formValue[`cw${i}`] || 'Y';
      }

      const payload = {
        productid: formValue.compproductid,
        widgets: widgetConfig,
        frequency: formValue.frequency,
        daytext: dayValue,
        csrftoken: this.CSRFToken
      };

      this.myconfigurationService.userdashboardconfigurationmodify(payload).subscribe(
        () => {
          Swal.fire({
            title: 'Your dashboard display configuration modified successfully!',
            icon: 'success',
            confirmButtonColor: 'green',
            confirmButtonText: 'Ok'
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        },
        (error) => {
          console.error('Dashboard config update failed:', error);
          Swal.fire({
            title: 'An error occurred',
            text: 'Please try again later',
            icon: 'error',
            confirmButtonColor: 'red',
            confirmButtonText: 'Ok'
          });
        }
      );
    });
  }

  onDayInput(event: any) {
    let value = event.target.value;
    value = value.toString().slice(0, 2);
    event.target.value = value;
  }
  getSelectedProductTooltip(): string {
    const selectedProductIds = this.modifyForm.get('products')?.value;
    if (selectedProductIds && selectedProductIds.length > 0) {
      const selectedProductNames = this.products
        .filter(product => selectedProductIds.includes(product.productid))
        .map(product => product.productname);
      return selectedProductNames.join(', ');
    }
    return 'No Product Selected';
  }
  getDefaultProductTooltip(id: number): string {
    const found = this.productList.find(opt => opt.productid === id);
    return found ? found.productname : 'Select product';
  }
}

export class Product {
  productid: string;
  productname: string;
  istopmenu: string;
}

export class DefaultProduct {
  productid: number;
  productname: string;
  defaultProductid: number;
}